import React from "react";
import PriceToggleBox from "../PriceToggleBox";
import PriceToggleRow from "../PriceToggleRow";

function PriceToggleContainer({ showPrice, showUVP, togglePrice, toggleUVP }) {
  return (
    <div className="w-full flex items-center justify-center">
      <PriceToggleBox onToggle={togglePrice}>
        <PriceToggleRow attribute="Preise einblenden" isChecked={showPrice} />
      </PriceToggleBox>
      <PriceToggleBox onToggle={toggleUVP} margin="left">
        <PriceToggleRow attribute="UVP einblenden" isChecked={showUVP} />
      </PriceToggleBox>
    </div>
  );
}

export default PriceToggleContainer;



// WEBPACK FOOTER //
// ./src/PriceToggleContainer/PriceToggleContainer.js